import Vue from "vue";
export default (() => {
    Vue.component("IconBed", () => import("./IconBed"));
    Vue.component("IconWaitConfirm", () => import("./IconWaitConfirm"));
    Vue.component("IconWarn", () => import("./IconWarn"));
    Vue.component("IconComplete", () => import("./IconComplete"));
    Vue.component("IconSvg", () => import("./IconSvg"));
})();